var _defs, _g, _line, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMainPageAccent(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    "data-name": "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 503.842,
    height: 200,
    viewBox: "0 0 503.842 200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .f {\n        fill: #C92D6E;\n      }\n\n      .g, .h {\n        fill: none;\n        stroke: #000;\n        stroke-miterlimit: 10;\n      }\n\n      .h {\n        stroke-width: 3px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "b",
    "data-name": "thickRings"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "h",
    cx: 381.527,
    cy: 99.478,
    rx: 85.093,
    ry: 82.237
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "h",
    cx: 304.429,
    cy: 99.581,
    rx: 85.093,
    ry: 82.237
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "h",
    cx: 199.531,
    cy: 99.364,
    rx: 85.093,
    ry: 82.237
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "h",
    cx: 122.433,
    cy: 101.649,
    rx: 85.093,
    ry: 82.237
  })), /*#__PURE__*/React.createElement("g", {
    id: "c",
    "data-name": "thinRings"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "g",
    cx: 122.336,
    cy: 101.957,
    rx: 74.963,
    ry: 72.448
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "g",
    cx: 200.138,
    cy: 100.843,
    rx: 72.394,
    ry: 69.965
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "g",
    cx: 304.332,
    cy: 100.785,
    rx: 73.298,
    ry: 70.838
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "g",
    cx: 382.294,
    cy: 99.361,
    rx: 75.179,
    ry: 72.656
  })))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    id: "d",
    "data-name": "straightLine",
    className: "h",
    x1: 8.609,
    y1: 105.997,
    x2: 495.171,
    y2: 105.997
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "e",
    "data-name": "pinkDots"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 114.4,
    cy: 106.354,
    rx: 8.512,
    ry: 8.282
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 389.408,
    cy: 104.817,
    rx: 8.512,
    ry: 8.282
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 250.964,
    cy: 163.99,
    rx: 8.512,
    ry: 8.282
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 250.166,
    cy: 32.556,
    rx: 8.512,
    ry: 8.282
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMainPageAccent);
export default __webpack_public_path__ + "static/media/mainPageAccent.fd7a7f9be01c84a0af5bf50e69632251.svg";
export { ForwardRef as ReactComponent };